var XPortal = XPortal || {};
XPortal.Dashboard = (function () {
    var self = {};
    self.ParentSearchRequests = [];

    self.Init = function (selector) {
        selector = selector ? selector : "body";
        if (XPortal.Measure) XPortal.Measure.Init($(selector));

        var $containers = $(selector).find(".dashboard-async-item");

        var $visibleContainers = [];
        $containers.each(function () {
            var $this = $(this);
            if (XPortal.Utils.isElementInsideVisibleTabsOrDD($this)) {
                $visibleContainers.push(this);
            }
        });

        $($visibleContainers).each(function () {
            var $this = $(this);
            $this.show();
            XPortal.Utils.EnsureActionInProfile($this);            
            $this.closest('.xportal-tab-panel, .xportal-dd-panel').addClass('inited');
            if ($this.hasClass("dashboard-async-item-processed")) {
                console.log("already processed dashboard-async-item", $this);
            } else {
                $this.addClass("dashboard-async-item-processed");
                $this.submit();
            }
        });

        self.RenderTrends(selector);
        self.InitSections(selector);
        self.ToolTipInit(selector);
    };

    self.InitSections = function (selector) {
        var $wrp = $(selector).hasClass("popup-detail-content") ? $(selector) : $(selector).find(".content-wrapper");
        $wrp.on("click", "a[data-target^='content']", function () {
            self.ClickForChangeSectionsLayout(this);
            var $this = $(this);
            XPortal.Dashboard.ChangeSectionsLayout($this.closest(".section"), '.' + $this.attr("data-target"));
        }).on("click", ".nav-link.choose-section-link", function () {
            var $tabPans = $(this).parents(".nav-tabs").next().find(">.tab-pane");
            var $currTab = $($(this).attr("href"));
            $tabPans.addClass("d-none");
            $currTab.removeClass("d-none");
            self.ClickForChangeSectionsLayout(this);
            var $gridNotInited = $currTab.find(".entity-grid:not(.inited)");
            if ($gridNotInited.length) {
                var gridSelector = "#" + $gridNotInited.closest(".xportal-tab-panel, .xportal-dd-panel").attr("id");
                self.InitSectionGrid(gridSelector);
            }
            var $comments = $currTab.find(".comments-cntbc:not(.inited-show-more)");
            if ($comments && $comments.length) {
                $comments.each(function () {
                    XPortal.Comments.HandleShowMoreAppearance($(this));
                    $(this).addClass('inited-show-more');
                });
            }
        });
        $(selector).find(".section .dropdown-menu > li:first-child:not('.d-none') > a[data-target]").each(function () { this.click(); });
    };

    self.InitSectionGrid = function (selector) {
        var $gridParent = $(selector).find('.grid-parent');
        $gridParent.css({ "opacity": "0" });
        setTimeout(function () {
            XPortal.Grid.PreInit(selector);
        }, 200);

        setTimeout(function () {
            $gridParent.css({ "opacity": "1" });
        }, 400);
    };

    self.ClickForChangeSectionsLayout = function (obj) {
        var $this = $(obj);
        var target = $this.hasClass("dropdown-menu-link") ? "." + $this.attr("data-target") : $this.attr("href");

        var $target = $(target);
        if ($target.closest('.xportal-tab-panel.inited, .xportal-dd-panel.inited').length)
            return;

        $target.find('.loader').removeClass('hidden');
        var $container = $target.find(".dashboard-async-item");
        if ($container.length) {
            XPortal.Utils.EnsureActionInProfile($container);
            $container.submit();
        }
        $target.closest('.xportal-tab-panel, .xportal-dd-panel').addClass('inited');
    };

    self.ChangeSectionsLayout = function ($section, layoutId) {
        $section.children(".section-content").children("div.item-content:not(" + layoutId + ")").addClass("d-none");
        $section.children(".section-header").children("div.item-content:not(" + layoutId + ")").addClass("d-none");

        var $layout = $(layoutId);
        $layout.removeClass("d-none");

        self.InitSectionGrid(layoutId);

        setTimeout(function () {
            var grid = $layout.find(".k-grid");
            if (grid.length > 0)
                XPortal.Grid.ResizeGrid(grid);

            var chart = $layout.find(".k-chart");
            if (chart.length > 0)
                XPortal.Chart.ResizeChart(chart);
        }, 50);

        XPortal.Measure.reInit($layout);
        XPortal.DropdownBtns.gridButtons.check($layout);
    };

    //The tile carries the color of its trend on its right border, and the border itself is plain css on .with-trend.
    //Which formatting rule matched is known only after Trending has rendered, so the direction and the color are read
    //back from what it produced rather than worked out for a second time here.
    function applyTrendToTile($holder) {
        var $trend = $holder.find(".block-item-trend-wrapper");
        var $tile = $holder.closest(".sm-block-item");
        if (!$trend.length || !$tile.length) return;

        var previous = $tile.attr("data-trend-direction");
        if (previous) $tile.removeClass(previous);

        var direction = $trend.attr("data-direction") || "";
        $tile.addClass(direction).attr("data-trend-direction", direction);

        //no rule color - the border falls back to the color of the direction, the one the theme carries
        var color = $trend[0].style.color;
        if (color) $tile[0].style.setProperty("--trend-color", color);
        else $tile[0].style.removeProperty("--trend-color");
    };

    //Cue tiles are rebuilt on every refresh, so the trend indicator has to be rendered again from its setup.
    //Called both after an ajax refresh and on init, so a tile that was rendered without the ajax round trip is covered too.
    self.RenderTrends = function (container) {
        var $container = $(container ? container : "body");
        var $holders = $container.find(".block-item-trend-holder[data-trend]");
        if (!$holders.length) return;

        $holders.each(function () {
            var $holder = $(this);
            var setup = null;
            try {
                setup = JSON.parse($holder.attr("data-trend") || "null");
            } catch (e) {
                console.error("can't read the trend setup of the tile.", e, $holder.attr("data-trend"));
            }
            if (!setup) return;
            $holder.html(XPortal.Format.Trending(setup, {}, $container.attr("id"), "trend"));
            applyTrendToTile($holder);
        });

        if (XPortal.ToolTips && !$container.data("xpand-tooltip") && $container.find("a.tooltip").length > 0)
            XPortal.ToolTips.Init($container, { filter: "a.tooltip", position: "bottom", width: "auto" });
    };
    
    self.ToolTipInit = function(container) {
        var $container = $(container ? container : "body");

        $container.kendoTooltip({
            filter: ".block-item .block-item-txt.block-item-lbl, .block-item .block-item-txt .block-item-digit, .block-item-breakdown .block-item-breakdown-title",
            position: "bottom",
            width: "auto",
            showAfter: 100,
            content: function (e) {
                const $target = $(e.target);
                const el = $target[0];

                const isOverflowing = el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;
                if (!isOverflowing) return;

                return $.trim($target.text());
            }
        });
    }

    self.Reloaded = function (obj) {
        var $this = $(obj);
        var updt = $($this.attr("data-ajax-update"));
        XPortal.Measure.Init(updt);
        if (updt && updt.length > 0 && XPortal && XPortal.FEditor && XPortal.FEditor.AjaxUpdated) {
            XPortal.FEditor.AjaxUpdated(updt);
            XPortal.FEditor.InitEditors(updt.parent());
        }

        var readTemplateData = function (element, data) {
            for (var i = 0; i < element.attributes.length; i++) {
                if (element.attributes[i].name.indexOf("data-") != 0) continue;
                var xval = parseFloat(element.attributes[i].value);
                data[element.attributes[i].name.substring(5)] = isNaN(xval) ? element.attributes[i].value : xval;
            }
            return data;
        };

        $this.find('.k-apply-format').each(function () {
            var tmplSrc = $(this).attr("data-template");
            if (tmplSrc && tmplSrc.length > 0) {
                var template = kendo.template(tmplSrc);
                var result = template(readTemplateData(this, { text: $(this).html() }));
                if ((result || "").trim() == ":") result = "";
                $(this).html("<span class='x-formated-value'>" + result + "</div>");
            }
        });

        $this.find('.x-apply-format').each(function () {
            var tmplSrc = $(this).attr("data-template");
            if (!tmplSrc || tmplSrc.length == 0) return;
            var data = readTemplateData(this, {});
            var raw = $(this).text();
            var result = XPortal.Template.TemplateToHtml(data, tmplSrc, null, null, data.value == null ? "" : String(data.value));
            if (result == null || String(result).length == 0) result = raw;
            $(this).html("<span class='x-formated-value'>" + result + "</span>");
        });

        self.RenderTrends($this);
        self.PrepareSearchRequest($(this).attr("id"));
    };

    self.SubscribeBlocksForUpdates = function (rootContainer) {
        rootContainer = $(rootContainer ? rootContainer : "body");
        rootContainer.find(".dashboard-amount-item, .dashboard-gauge-item, .dashboard-chart-item").each(function (index, item) {
            var container = $(item);
            if (container.attr("data-subscribed") === "1") return;
            container.attr("data-subscribed", "1");

            var containerId = container.attr("id");
            var type = container.attr("data-childrelationtype");
            var parentDatasourceId = container.attr("data-parentdatasource-id");
            if (type === "grid") {
                var gridId = "entity-grid-" + parentDatasourceId;
                var grid = $("#" + gridId);
                var onGridSearch = function (e, searchRequest) {
                    if ($(e.target).attr("id") !== gridId) {
                        return;
                    }

                    self.ParentSearchRequests[containerId] = searchRequest;

                    self.PrepareSearchRequest(containerId);
                    self.RebuildBlock(containerId);
                }
                if (grid.length > 0) {
                    grid.on("grid.onsearch", onGridSearch);
                }
            }
            if (type === "facet") {
                var facetId = "facetfilters-" + parentDatasourceId;
                var facet = $("#" + facetId);
                var onFacetSearch = function (e, searchRequest) {
                    if ($(e.target).attr("id") !== facetId) {
                        return;
                    }

                    self.ParentSearchRequests[containerId] = searchRequest;

                    self.PrepareSearchRequest(containerId);
                    self.RebuildBlock(containerId);
                }
                if (facet.length > 0) {
                    facet.on("facet.onsearch", onFacetSearch);
                }
            }
        });
    };

    self.PrepareSearchRequest = function (containerId) {
        var searchRequestInput = $("#" + containerId).find("input[name='SearchRequest']");
        if (searchRequestInput.length > 0) {
            var searchRequest = self.ParentSearchRequests[containerId];
            if (searchRequest) {
                searchRequestInput.val(kendo.stringify(searchRequest));
            }
            else {
                searchRequestInput.val("");
            }
        }
    };

    self.RebuildBlock = function (containerId) {
        const container = $("#" + containerId);
        let interval = container.data("changedInteval");
        interval = interval ? interval : 0;
        clearTimeout(interval);
        interval = setTimeout(function () {
            XPortal.Utils.EnsureActionInProfile(container);
            container.submit();
        }, 500);
        container.data("changedInteval", interval);
    };

    return self;
}());
